const env = process.env.NODE_ENV || "development";

const domainEnvironment = {
  development: {
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName:"",
  },
  production: {
      domainAdminSide: "https://admin.vinhphuc.cgis.asia",
      domainUserSide: "https://vinhphuc.cgis.asia",
      domainName:"vinhphuc.cgis.asia",
  },
};

module.exports = domainEnvironment[env];
